import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { WishListItem } from "../../common/wishListItem/WishListItem";
import { ProductListingProps } from "../../types/ProductList";
import { useWishlist, useToggleWishlist } from "../../queries/wishlist";
import { mapProducts } from "../../utils/productListMapping";
import { WishlistEndPoints } from "../../constants/endpoints";
import emptyWishlistIcon from "../../assets/emptyWishlistIcon.svg";
import { useAppDispatch } from "../../redux/hooks";
import { useNavigate } from "react-router-dom";
import {
  removeFromWishlist,
  setWishlist,
} from "../../redux/features/slices/wishlistSlice";

import {
  WishlistTitle,
  WishlistContainer,
  EmptyWishlistBox,
  EmptyWishlistImage,
  EmptyWishlistText,
  ExploreButton,
} from "./Wishlist.Styles";

const ProductWishlist = () => {
  const [products, setProducts] = useState<ProductListingProps[]>([]);
  const [error, setError] = useState(false);
  const customerId = localStorage.getItem("customerId") || "";
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const orgId = localStorage.getItem("orgId");

  const { data, isLoading, isError } = useWishlist(customerId);
  const toggleWishlist = useToggleWishlist(customerId);

  useEffect(() => {
    if (isLoading) return;

    if (isError || !data?.products) {
      setError(true);
      setProducts([]);
      return;
    }

    const mapped = mapProducts(data.products);
    setProducts(mapped);
    setError(false);

    const wishlistIds = data.products.map((p: any) => p.id);
    dispatch(setWishlist(wishlistIds));
  }, [data, isLoading, isError, dispatch]);

  const handleRemove = async (productId: string) => {
    try {
      await toggleWishlist.mutateAsync(productId);
      dispatch(removeFromWishlist(productId));
      setProducts((prev) => prev.filter((item) => item.id !== productId));
    } catch (error) {
      console.error("Error removing from wishlist:", error);
    }
  };

  const handleViewAll = () => {
    navigate(`/maltora-customer/products`);
  };

  return (
    <Box>
      <WishlistTitle variant="body1">Wishlist</WishlistTitle>

      {products.length > 0 ? (
        <WishlistContainer>
          {products.map((item) => (
            <WishListItem
              key={item.id}
              {...item}
              onDelete={() => handleRemove(item.id)}
            />
          ))}
        </WishlistContainer>
      ) : (
        <>
          <EmptyWishlistBox>
            <EmptyWishlistImage src={emptyWishlistIcon} alt="Empty Wishlist" />
            <EmptyWishlistText>
              You have nothing saved yet.
              <br />
              Please explore our brews and your favorites will appear here!
            </EmptyWishlistText>
            <ExploreButton onClick={handleViewAll}>
              Explore our Brews
            </ExploreButton>
          </EmptyWishlistBox>
        </>
      )}
    </Box>
  );
};

export default ProductWishlist;
